var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g({staticClass:"p-2",attrs:{"variant":"link","size":"sm"}},_vm.$listeners),[(_vm.open)?_c('b-icon-chevron-up'):_c('b-icon-chevron-down')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }